// Mapeamento agent_health.state (5 valores do banco) -> frame do spritesheet
// (6 linhas do grid entregue por E04) — ver design.md decisão 6 para o
// raciocínio completo. `thinking` vira overlay de balão sobre o frame base;
// `sucesso` e `ausente` são derivados client-side, sem valor correspondente
// no banco.
const STALE_THRESHOLD_MS = 15 * 60 * 1000;
const SUCCESS_FLASH_MS = 2000;

const DB_STATE_TO_FRAME = {
  idle: "idle",
  working: "trabalhando",
  error: "erro",
  waiting_human: "escalado",
};

export function createSpriteStateTracker(requestRerender) {
  // agentName -> { lastBodyFrame: 'idle'|'trabalhando', lastDbState, successFlashUntil: number|null }
  const perAgent = new Map();

  function getEntry(agentName) {
    let entry = perAgent.get(agentName);
    if (!entry) {
      entry = { lastBodyFrame: "idle", lastDbState: null, successFlashUntil: null };
      perAgent.set(agentName, entry);
    }
    return entry;
  }

  function resolve(agentName, health) {
    const entry = getEntry(agentName);
    const now = Date.now();

    if (!health) {
      return { frame: "ausente", showThinkingBubble: false };
    }

    const dbState = health.state;

    if (entry.lastDbState === "working" && dbState === "idle" && !entry.successFlashUntil) {
      entry.successFlashUntil = now + SUCCESS_FLASH_MS;
      setTimeout(() => {
        entry.successFlashUntil = null;
        requestRerender();
      }, SUCCESS_FLASH_MS);
    }
    entry.lastDbState = dbState;

    if (dbState === "idle" || dbState === "working") {
      entry.lastBodyFrame = DB_STATE_TO_FRAME[dbState];
    }

    const updatedAt = health.updatedAt ?? health.lastExecutionAt;
    const isStale = updatedAt ? now - new Date(updatedAt).getTime() > STALE_THRESHOLD_MS : false;
    if (isStale) {
      return { frame: "ausente", showThinkingBubble: false };
    }

    if (entry.successFlashUntil) {
      return { frame: "sucesso", showThinkingBubble: false };
    }

    if (dbState === "thinking") {
      return { frame: entry.lastBodyFrame, showThinkingBubble: true };
    }

    return { frame: DB_STATE_TO_FRAME[dbState] ?? entry.lastBodyFrame, showThinkingBubble: false };
  }

  return { resolve };
}

export const SPRITE_FRAME_ROW = {
  idle: 0,
  trabalhando: 1,
  sucesso: 2,
  erro: 3,
  escalado: 4,
  ausente: 5,
};
